export enum STEP_STATUS {
  Success = 1,
  Fail,
  Running,
  Scheduled,
  InQueue,
  Recurring,
  Stopped,
  Canceled
}

export const BATCH_PROCESSING_OCCURRENCE_TYPE = {
  IMMEDIATELY: "immediately",
  ONE_TIME: "one-time",
  RECURRING: "recurring",
}

export const BATCH_PROCESSING_END_TYPE = {
  ON: "On",
  NEVER: "Never",
}

export const BATCH_PROCESSING_CRON_REPEAT_TYPE = {
  MINUTE: "minute",
  HOUR: "hour",
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
}

export const CUSTOM_QUERY_PROCEDURE_NAMES = {
  RUN_SINGLE_QUERY: "Run Single Query",
};

export const CUSTOM_QUERY_STEP_PARAMETERS = {
  SELECT_GROUP_CODE: "customQueryGroupCode",
  SELECT_CATEGORY: "customQueryCategory",
  SELECT_QUERY: "customQueryQuery",
  CREATE_TABLE: "customQueryCreateTable",
  INPUT_FIELDS: "customQueryInputFields"
};

export const EXTRACTION_PROCEDURE_NAMES = {
  RUN_SINGLE_QUERY: "Run Single Query",
  IMPORT_SOURCE: "Import Source",
  IMPORT_FROM_FILE_REPOSITORY: "Import from File Repository",
  IMPORT_FROM_SHAREPOINT: "Import from SharePoint",
  PROCESS_CLUSTERING: "Process clustering",
};

export const IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS = {
  SOURCE_ID: "sourceId",
  FILE_PATH: "filePath",
  DESTINATION_GROUP_CODE: "destinationGroupCode",
  DESTINATION_ENTITY: "destinationEntity",
  DESTINATION_DATABASE: "destinationDatabase",
  DESTINATION_SCHEMA: "destinationSchema",
  DESTINATION_TABLE_NAME: "destinationTableName",
  CHECKED_KEYS: "checkedKeys",
  SYSTEM_ID: "systemId"
}

export const IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS = {
  SOURCE_ID: "sourceId",
  FILE_PATH: "filePath",
  DESTINATION_GROUP_CODE: "destinationGroupCode",
  DESTINATION_ENTITY: "destinationEntity",
  DESTINATION_DATABASE: "destinationDatabase",
  DESTINATION_SCHEMA: "destinationSchema",
  DESTINATION_TABLE_NAME: "destinationTableName",
  CHECKED_KEYS: "checkedKeys",
  SYSTEM_ID: "systemId"
}

export const EXTRACTION_STEP_PARAMETERS = {
  SOURCE_TYPE: "sourceType",
  FILE_NAME: "fileName",
  SOURCE_ID: "sourceId",
  SOURCE_SERVER: "sourceServer",
  SOURCE_DATABASE: "sourceDatabase",
  SOURCE_USER: "sourceUser",
  SOURCE_PASSWORD: "sourcePassword",
  SOURCE_TABLE_NAME: "sourceTableName",
  SOURCE_QUERY: "sourceQuery",
  DESTINATION_SCHEMA: "destinationSchema",
  DESTINATION_TABLE_NAME: "destinationTableName",
  DESTINATION_ENTITY: "destinationEntity",
  DESTINATION_GROUP_CODE: "destinationGroupCode",
  DESTINATION_DATABASE: "destinationDatabase",
  CHECKED_KEYS: "checkedKeys",
  SYSTEM_ID: "systemId",
}

export const CLUSTERING_STEP_PARAMETERS = {
  GROUP_CODE: "@chrGroupCode"
}

export const EXTRACTION_IMPORT_TYPES = {
  DATABASE_OBJECT: "Database object",
  CUSTOM_QUERY: "Custom query"
}

export const EXTRACTION_SOURCE_TYPES = {
  FILE_ON_THIS_COMPUTER: "file-on-this-computer",
  FILE_REPOSITORY: "file-repository",
  SHAREPOINT: "sharepoint",
  MS_SQL: "ms-sql"
}

export const BATCH_PROCESSING_MAP_STATUS = (status: any) => {
  if (status === 1) {
    return "Success";
  }
  if (status === 2) {
    return "Fail";
  }
  if (status === 3) {
    return "Running";
  }
  if (status === 4) {
    return "Scheduled";
  }
  if (status === 5) {
    return "In Queue";
  }
  if (status === 6) {
    return "Recurring";
  }
  if (status === 7) {
    return "Stopped";
  }
  if (status === 8) {
    return "Canceled";
  }
};

export const BATCH_PROCESSING_MAP_STATUS_REVERSE = (status: string) => {
  if (status === "Success") {
    return 1;
  }
  if (status === "Fail") {
    return 2;
  }
  if (status === "Running") {
    return 3;
  }
  if (status === "Scheduled") {
    return 4;
  }
  if (status === "In Queue") {
    return 5;
  }
  if (status === "Recurring") {
    return 6;
  }
  if (status === "Stopped") {
    return 7;
  }
  if (status === "Canceled") {
    return 8;
  }
};
